import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { ObjectInput } from '../data-entry-ui/ObjectInput';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import { CopyTournamentParams } from 'functions/src/callable/tournament/copyTournament.f';
import { LoadingButton } from '../buttons/LoadingButton';
import {
  toFormInput,
  EditableTournament,
} from 'src/util/tournaments/toFormInput';
import {
  withoutWizardProps,
  WizardElementProps,
} from 'src/components/wizard/Wizard';

export type CopyTournamentFormProps = {
  tournament: EditableTournament & { id: string };
};

// Implement the withoutWizardProps and WizardElementProps
export const CopyTournamentForm = withoutWizardProps(
  ({
    set,
    go,
    tournament,
  }: WizardElementProps<{ message: string; success: boolean }, string> &
    CopyTournamentFormProps) => {
    const theme = useTheme();
    const [tournamentNew, setTournamentNew] =
      useState<EditableTournament>(tournament);
    const input = toFormInput(tournamentNew);
    // eslint-disable-next-line @blumintinc/blumint/extract-global-constants
    const handleSubmit = async () => {
      // eslint-disable-next-line @blumintinc/blumint/extract-global-constants
      const { copyTournament } = await import(
        '../../firebaseCloud/tournament/copyTournament'
      );

      const fieldsToOverwrite = {
        ...tournamentNew,
        date: tournamentNew.date.getTime(),
        endDate: tournamentNew.endDate.getTime(),
        checkInTime: tournamentNew.checkInTime.getTime(),
        readyTime: tournamentNew.readyTime.getTime(),
      };

      try {
        const tournamentIdOld = tournament.id;
        const copyTournamentParams: CopyTournamentParams = {
          tournamentId: tournamentIdOld,
          fieldsToOverwrite,
        };
        await copyTournament(copyTournamentParams);
        set('message', `Tournament added successfully!`);
        set('success', true);
      } catch (error) {
        set('message', 'Error creating tournament. Please try again.');
        set('success', false);
        console.error('Error creating tournament:', error);
      }
      go('OutcomeSubmit');
    };

    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: 3,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            overflow: 'auto',
            border: `1px ${theme.palette.primary.main} solid`,
            backgroundColor: theme.palette.background.elevation[10],
            borderRadius: 2,
            maxHeight: '500px',
            width: '500px',
            p: 3,
          }}
        >
          <ObjectInput
            input={input}
            onChange={(tournamentNew) => {
              setTournamentNew(tournamentNew);
            }}
            object={tournament}
          />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <LoadingButton
            variant="contained"
            onClick={handleSubmit}
            color="secondary"
          >
            Submit
          </LoadingButton>
          <Button
            variant="contained"
            onClick={() => go(undefined)}
            color="error"
          >
            Close
          </Button>
        </Box>
      </Box>
    );
  },
);
